import { environment } from "src/environments/environment";
import {
  isFunction,
  isPlainObject,
  replace,
  toLower,
  toPairs
} from "lodash-es";

export const API = generateEndpoints(
  {
    CALENDAR: {
      APPOINTMENTS: {
        LIST: () => ``,
        ID: (appointmentId: string) => `/${appointmentId}`
      },
      PUBLIC: {
        APPOINTMENTS: {
          ID: (appointmentId: string) => `/${appointmentId}`
        }
      }
    },
    DIRECTORY: {
      PATIENTS: {
        CREATE: () => ``,
        ID: (patientId: string) => `/${patientId}`
      }
    },
    BILLING: {
      FISCAL_PROFILES: {
        ID: (fiscalProfileId: string) => `/${fiscalProfileId}`
      },
      QUOTES: {
        ID: (quoteId: string) => `/${quoteId}`,
        ID_ACCEPT: (quoteId: string) => `/${quoteId}/accept`,
        ID_REJECT: (quoteId: string) => `/${quoteId}/reject`,
        ID_UNACCEPT: (quoteId: string) => `/${quoteId}/unaccept`,
        ID_UNREJECT: (quoteId: string) => `/${quoteId}/unreject`
      }
    },
    HEALTHCARE: {
      HEALTH_RECORDS: {
        ID_ATTACHMENTS: (healthRecordId: string) =>
          `/${healthRecordId}/attachments`
      }
    }
  },
  {},
  ""
);

function generateEndpoints<T extends Record<string, any>>(
  data: T,
  structure: any,
  path: string
): T {
  toPairs(data).forEach(([key, value]) => {
    switch (true) {
      case isPlainObject(value): {
        let prefix = "";
        if ((<any>environment.snoots.api)[toLower(key)]) {
          prefix = `${(<any>environment.snoots.api)[toLower(key)]}`;
        } else {
          prefix = `${path}/${toLower(key).replace("-", "_")}`;
        }

        structure[key] = generateEndpoints(value, {}, prefix);
        break;
      }
      case isFunction(value): {
        structure[key] = (...args: any[]) =>
          replace(`${path}${value.apply(null, args)}`, /_/gi, "-");
        break;
      }
    }
  });

  return structure;
}
